import { FULL_DAYS, type FullDay } from "../data/days";

/**
 * Parse an "h:mm AM/PM" string into minutes since midnight.
 * Returns a sentinel (9999) for missing or "—" placeholder times so they
 * sort to the end.
 */
export function timeToMins(t: string | undefined): number {
  if (!t || t === "—") return 9999;
  const [time, ampm] = t.split(" ");
  const parts = time.split(":").map(Number);
  let h = parts[0] ?? 0;
  const m = parts[1] ?? 0;
  if (ampm === "PM" && h !== 12) h += 12;
  if (ampm === "AM" && h === 12) h = 0;
  return h * 60 + m;
}

/** 1-indexed: which occurrence of the weekday this date is in the month (1=first). */
export function getWeekOfMonth(date: Date): number {
  return Math.ceil(date.getDate() / 7);
}

/** "Monday", "Tuesday" etc for a JS Date (week starts Monday). */
export function getDayName(date: Date): FullDay {
  const jsDay = date.getDay();
  return FULL_DAYS[jsDay === 0 ? 6 : jsDay - 1];
}
